import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteProductCategories,
	listProductCategories,
	readProductCategory
} from "../../redux/actions/table/superadmin/product_categories";
import ProductCategoriesFlyout from "../../flyouts/superadmin/product_categories/ProductCategoriesFlyout";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_product_categories"],
	application_language_id: state.auth.language_id,
}))
class ProductCategories extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_product_category && setPlusActions([{
			title: "Add product category",
			onClick: () => setTableParams('superadmin_product_categories', {
				add_product_category_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readProductCategory(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
			{
				key: "priority",
				name: "Priority",
				value: priority => priority
			},
		];

		const singleActions = (product_category_id) => {
			return [
				<Tooltip text="Delete selected product category" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected product category?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteProductCategories([product_category_id]).then(() => {
												hideAlertbox();

												setNotification("The selected product category has been deleted.");
												listProductCategories();

												setTableParams('superadmin_product_categories', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (product_categories_ids) => [
			<Tooltip text="Delete selected product categories" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these product categories?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteProductCategories(product_categories_ids).then(() => {
											hideAlertbox();

											setNotification("The selected product categories have been deleted.");
											listProductCategories();

											setTableParams('superadmin_product_categories', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<ProductCategoriesFlyout
				data={this.state.preview}
				readAction={product_category_id => {
					return new Promise(resolve => {
						readProductCategory(getURLParam('id') || product_category_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listProductCategories}
				name="superadmin_product_categories"
				groupActions={superadmin.delete_product_category && groupActions}
				singleActions={superadmin.delete_product_category && singleActions}
				title={__("modules.submodules.title.product-categories")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default ProductCategories;
